<template>
  <v-list dense id="continue">
    <template v-for="(shownGroup, index) in shownGroupings">
      <v-subheader :key="`group-subheader-${index}`">
        {{ shownGroup.name }}
        <v-spacer />
        <v-btn v-if="isTenantAdmin" flat icon @click="toggleEditSettings(shownGroup.sourceType)">
          <v-icon v-if="groupStates[shownGroup.sourceType].editing" color="error lighten-1">close</v-icon>
          <v-icon v-else>edit</v-icon>
        </v-btn>
      </v-subheader>
      <template v-if="groupStates[shownGroup.sourceType].editing && isTenantAdmin">
        <v-card :key="`group-edit-card-${index}`">
          <v-card-actions style="padding-bottom: 0px">
            <v-subheader class="removePadding">Group stations:</v-subheader>
            <v-spacer />
            <v-btn small color="secondary" :loading="groupStates[shownGroup.sourceType].loading" @click="save(shownGroup.sourceType)">
              {{ $t('Button.apply') }}
            </v-btn>
          </v-card-actions>
          <v-card-text style="padding-top: 0px">
            <v-combobox v-model="groupStates[shownGroup.sourceType].selected" :items="groupStates[shownGroup.sourceType].items" :menu-props="{offsetX: true, nudgeTop: 45}" solo chips label="Select group" multiple persistent-hint item-text="name" item-value="name" return-object deletable-chips />
          </v-card-text>
        </v-card>
      </template>
      <SideMenuGrouper v-if="shownGroup.group" :key="`group-side-menu-grouper-${index}`" :groups="shownGroup.group" :groupSettings="sideMenuSettings[shownGroup.sourceType]" />
      <v-divider :key="`group-divider-${index}`" />
    </template>
  </v-list>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  const stations = createNamespacedHelpers('stations')
  const navigation = createNamespacedHelpers('navigation')
  const authenticate = createNamespacedHelpers('authenticate')

  import {
    groupTypes,
    sourceGroupTypes,
  } from '@/store/UI/navigation'

  import SideMenuGrouper from './SideMenuGrouper'
  export default {
    components: {
      SideMenuGrouper,
    },
    data() {
      return {
        SOURCE_TYPES,
        groupTypes: Object.values(groupTypes),
        groupStates: {
          [SOURCE_TYPES.discreteEnvirodata]: {
            editing: false,
            items: sourceGroupTypes[SOURCE_TYPES.discreteEnvirodata],
            selected: [],
            loading: false,
          },
          [SOURCE_TYPES.continuousAquarius]: {
            editing: false,
            items: sourceGroupTypes[SOURCE_TYPES.continuousAquarius],
            selected: [],
            loading: false,
          },
          [SOURCE_TYPES.vegetativeMonitoringEnvirodata]: {
            editing: false,
            items: sourceGroupTypes[SOURCE_TYPES.vegetativeMonitoringEnvirodata],
            selected: [],
            loading: false,
          },
          [SOURCE_TYPES.surveysEnvirodata]: {
            editing: false,
            items: sourceGroupTypes[SOURCE_TYPES.surveysEnvirodata],
            selected: [],
            loading: false,
          },
        },
      }
    },
    computed: {
      ...stations.mapGetters([
        'distinctStations',
        'stationCategories',
      ]),
      ...navigation.mapGetters([
        'sideMenuGrouping',
        'sideMenuSettings',
      ]),
      ...authenticate.mapGetters(['isTenantAdmin']),
      shownGroupings() {
        let groupings = [{
          name: this.$t('StationSideMenu.ContinuousDataStations'),
          group: this.sideMenuGrouping.ContinuousGroup,
          sourceType: SOURCE_TYPES.continuousAquarius,
        },
        {
          name: this.$t('StationSideMenu.DiscreteSampleStations'),
          group: this.sideMenuGrouping.DiscreteGroup,
          sourceType: SOURCE_TYPES.discreteEnvirodata,
        },
        {
          name: this.$t('StationSideMenu.VegetativePlots'),
          group: this.sideMenuGrouping.VegetativeGroup,
          sourceType: SOURCE_TYPES.vegetativeMonitoringEnvirodata,
        },
        {
          name: this.$t('StationSideMenu.SurveyLocations'),
          group: this.sideMenuGrouping.SurveyGroup,
          sourceType: SOURCE_TYPES.surveysEnvirodata,
        },
        ]
        return groupings.filter(x => x.group && x.group.length > 0)
      },
    },
    methods: {
      ...navigation.mapActions(['saveSideMenuSetting', 'fetchSideMenu']),
      getGroupTypes(settingType) {
        let settings = this.sideMenuSettings[settingType]
        if (settings) return settings.GroupType || []
      },
      toggleEditSettings(settingType) {
        let groupState = this.groupStates[settingType]
        groupState.editing = !groupState.editing

        groupState.selected = this.getGroupTypes(settingType).map(setting =>
          this.groupTypes.find(gt => gt.value == setting))
      },
      async save(settingType) {
        let groupState = this.groupStates[settingType]
        groupState.loading = true
        let groupType = groupState.selected.map(s => s.value)

        let settings = {
          ...this.sideMenuSettings[settingType],
          GroupType: groupType,
        }

        await this.saveSideMenuSetting({
          settings,
        })

        await this.fetchSideMenu()

        groupState.loading = false
      },
    },
  }
</script>